import React, { useEffect } from 'react';
import { useAppDispatch } from 'redux/hooks';
import { logout } from 'redux/auth/authActions';
import LoadingState from '../../components/LoadingState';

export default function Logout() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    void dispatch(logout());
  }, []);

  return <LoadingState />;
}
